<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";

export default {
  data() {
    return {
      opportunity: null,
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },

  components: {
    Jobs,
    SearchJob,
  },
};
</script>

<template>
  <div class="collection">
    <div class="container">
      <h1>nosso escritório</h1>
      <p>
        Localizado na Vila Leopoldina, a matriz administrativa da Restoque conta com mais de 500 colaboradores espalhados nas áreas de Atacado, Comercial, E-commerce, Estilo, Financeiro, Marketing, RH, SAC, TI, entre outras. Anexo ao nosso escritório, fica também um dos nossos Centros Logísticos.
      </p>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.collection {
    margin-top: 4rem;
}
h1 {
    font-size: 1.9rem;
    text-transform: uppercase;
    font-weight: 500;
    color: #000;
}
p {
    font-size: 1.2rem;
    color: #000;
    margin-top: 1rem;
     border-bottom: 2px solid theme-color(primary);
     padding-bottom: 2rem;
     margin-bottom: 1.5rem;
}
</style>